export const LOGOUT = 'LOGOUT';

export const AUTH_FLOW_BEGIN = 'AUTH_FLOW_BEGIN';
export const AUTH_FLOW_END = 'AUTH_FLOW_END';

export const FETCH_PROFILE_REQUESTING = 'FETCH_PROFILE_REQUESTING';
export const FETCH_PROFILE_ABORTED = 'FETCH_PROFILE_ABORTED';
export const FETCH_PROFILE_FAILED = 'FETCH_PROFILE_FAILED';
export const FETCH_PROFILE_SUCCEEDED = 'FETCH_PROFILE_SUCCEEDED';

export const REFRESH_PROFILE = 'REFRESH_PROFILE';

export const FETCH_PRODUCT_SUBSCRIPTIONS = 'FETCH_PRODUCT_SUBSCRIPTIONS';
export const FETCH_PRODUCT_SUBSCRIPTIONS_REQUESTING = 'FETCH_PRODUCT_SUBSCRIPTIONS_REQUESTING';
export const FETCH_PRODUCT_SUBSCRIPTIONS_ABORTED = 'FETCH_PRODUCT_SUBSCRIPTIONS_ABORTED';
export const FETCH_PRODUCT_SUBSCRIPTIONS_FAILED = 'FETCH_PRODUCT_SUBSCRIPTIONS_FAILED';
export const FETCH_PRODUCT_SUBSCRIPTIONS_SUCCEEDED = 'FETCH_PRODUCT_SUBSCRIPTIONS_SUCCEEDED';

export const FETCH_FAVORITE_DRAMAS = 'FETCH_FAVORITE_DRAMAS';
export const FETCH_FAVORITE_DRAMAS_REQUESTING = 'FETCH_FAVORITE_DRAMAS_REQUESTING';
export const FETCH_FAVORITE_DRAMAS_ABORTED = 'FETCH_FAVORITE_DRAMAS_ABORTED';
export const FETCH_FAVORITE_DRAMAS_SUCCEEDED = 'FETCH_FAVORITE_DRAMAS_SUCCEEDED';
export const FETCH_FAVORITE_DRAMAS_FAILED = 'FETCH_FAVORITE_DRAMAS_FAILED';

export const ADD_FAVORITE_DRAMA = 'ADD_FAVORITE_DRAMA';
export const ADD_FAVORITE_DRAMA_OPTIMISTIC = 'ADD_FAVORITE_DRAMA_OPTIMISTIC';

export const REMOVE_FAVORITE_DRAMA = 'REMOVE_FAVORITE_DRAMA';
export const REMOVE_FAVORITE_DRAMA_OPTIMISTIC = 'REMOVE_FAVORITE_DRAMA_OPTIMISTIC';

export const FETCH_WATCH_HISTORY = 'FETCH_WATCH_HISTORY';
export const FETCH_WATCH_HISTORY_REQUESTING = 'FETCH_WATCH_HISTORY_REQUESTING';
export const FETCH_WATCH_HISTORY_ABORTED = 'FETCH_WATCH_HISTORY_ABORTED';
export const FETCH_WATCH_HISTORY_SUCCEEDED = 'FETCH_WATCH_HISTORY_SUCCEEDED';
export const FETCH_WATCH_HISTORY_FAILED = 'FETCH_WATCH_HISTORY_FAILED';

export const UPDATE_WATCH_HISTORY = 'UPDATE_WATCH_HISTORY';
export const UPDATE_WATCH_HISTORY_REQUESTING = 'UPDATE_WATCH_HISTORY_REQUESTING';
export const UPDATE_WATCH_HISTORY_ABORTED = 'UPDATE_WATCH_HISTORY_ABORTED';
export const UPDATE_WATCH_HISTORY_SUCCEEDED = 'UPDATE_WATCH_HISTORY_SUCCEEDED';
export const UPDATE_WATCH_HISTORY_FAILED = 'UPDATE_WATCH_HISTORY_FAILED';

export const DELETE_ALL_WATCH_HISTORY = 'DELETE_ALL_WATCH_HISTORY';
export const DELETE_ALL_WATCH_HISTORY_OPTIMISTIC = 'DELETE_ALL_WATCH_HISTORY_OPTIMISTIC';

export const DELETE_WATCH_HISTORY = 'DELETE_WATCH_HISTORY';
export const DELETE_WATCH_HISTORY_OPTIMISTIC = 'DELETE_WATCH_HISTORY_OPTIMISTIC';

export const SELECT_UNSUBSCRIPTION = 'SELECT_UNSUBSCRIPTION';
export const RESET_UNSUBSCRIPTION = 'RESET_UNSUBSCRIPTION';
export const UNSUBSCRIBE = 'UNSUBSCRIBE';
export const UNSUBSCRIBE_REQUESTING = 'UNSUBSCRIBE_REQUESTING';
export const UNSUBSCRIBE_FAILED = 'UNSUBSCRIBE_FAILED';
export const UNSUBSCRIBE_SUCCEEDED = 'UNSUBSCRIBE_SUCCEEDED';

export const FETCH_POLICIES_SUCCEEDED = 'FETCH_POLICIES_SUCCEEDED';
export const UPDATE_POLICIES = 'UPDATE_POLICIES';

export const IAP_WITH_CANCELLED = 'IAP_WITH_CANCELLED';
export const IAP_WITHOUT_CANCELLED = 'IAP_WITHOUT_CANCELLED';
export const NOT_IAP_WITH_CANCELLED = 'NOT_IAP_WITH_CANCELLED';
export const NOT_IAP_WITHOUT_CANCELLED = 'NOT_IAP_WITHOUT_CANCELLED';